/* eslint-disable @typescript-eslint/await-thenable */
import { useAppDispatch, useAppSelector } from 'store/hooks';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, styled } from '@mui/material';
import { Column } from 'ui/Flex';
import { MobileLayout } from 'ui/MobileLayout';
import { ContentTemplate } from './models/ContentTemplate';
import { MobileContentRenderer } from './MobileContentRenderer';
import { createAppLayoutFromTemplate } from 'store/content/contentSlice';

const PREFIX = 'ConditionValue';

const classes = {
    column: `${PREFIX}-column`
};

const StyledColumn = styled(Column)(({ theme }) => ({
    margin: theme.spacing(12),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(3),
    [`& .${classes.column}`]: {
        marginTop: theme.spacing(2)
    }
}));

interface ContentTemplateItemProps {
    template: ContentTemplate;
}

export const ContentTemplateItem: React.FC<ContentTemplateItemProps> = ({ template }) => {
    const dispatch = useAppDispatch();
    const { isLoading } = useAppSelector(state => state.content);
    const navigate = useNavigate();
    const handleButtonClick = React.useCallback(() => {
        dispatch(createAppLayoutFromTemplate(template, navigate));
    }, [dispatch, navigate, template]);
    return (
        <StyledColumn>
            <MobileLayout>
                <MobileContentRenderer anchor={template.anchor} modules={template.anchor.modules} />
            </MobileLayout>
            <Column align="center" className={classes.column}>
                <Button
                    sx={{ mt: 2 }}
                    disabled={isLoading}
                    variant="contained"
                    color="primary"
                    onClick={handleButtonClick}
                >
                    Select this layout
                </Button>
            </Column>
        </StyledColumn>
    );
};
